import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/email-templates_/$templateId')({
  staticData: { title: 'Email template' },
})
